<template>
  <a-card>
    <a-form>
      <a-form-item class='mb15' label="验证提货码" name='code'>
        <a-input-search v-model:value="code" placeholder="请输入提货码" :loading="listLoading" @search="initData" enter-button />
      </a-form-item>
    </a-form>
    <div class="s_p24" v-if="detail.order_sn">
      <p class="s_c333  s_lin_h35">买家信息：{{detail.buyer_name}}</p>
      <p class="s_c333  s_lin_h35"> 收货信息：{{detail.name}}，{{detail.mobile}}，{{detail.address}}</p>
      <p class="s_c333  s_lin_h35">下单时间：{{detail.create_time}}</p>
      <p class="s_c333  s_lin_h35">订单号： {{detail.order_sn}}</p>
      <p class="s_c333 s_fonts14  m-b-20">商品清单：</p>
      <a-table :pagination='false' bordered rowKey='id' :columns='columns' :data-source='detail.order_goods'>
        <template v-slot:good="{ record }">
          <a-card-meta>
            <template #avatar>
              <img :src="info.picdomain+'/'+(record.goods_image)" alt="" style="width:50px">
            </template>
            <template #description>
              <p class="s_omit">{{record.goods_name}}</p>
            </template>
          </a-card-meta>
        </template>
        <template v-slot:product_price="{ record }">
          <p>￥{{record.product?record.product.product_price : '-'}}<span v-if="$route.query.order_type == 'point'">+{{record.product.point}}积分</span></p>
        </template>
        <template v-slot:coupon_price="{ record }">
          <p>{{record.coupon_price || '-'}}</p>
        </template>
        <template v-slot:total_pay_price="{ record }">
          <p>￥{{record.total_pay_price}}<span v-if="$route.query.order_type == 'point'">+{{record.total_pay_point}}积分</span></p>
        </template>
      </a-table>
      <div class="s_flex_center" style="position:fixed;bottom:0;width:100%;left:0;padding:15px;background-color:#ccc">
        <a-button type="primary" v-has:channerlPickupCodeWriteOff="writeOff">核销</a-button>
      </div>
    </div>
    <a-result :title="searchResult" v-if="listDone">
    </a-result>
  </a-card>
</template>
<script>
import { ref } from "@vue/reactivity";
import {
  getChannelOrderPickUpCodeWriteOff,
  getChannelOrderPickUpCodeSearch,
} from "@/api/order";
import { message, Modal } from "ant-design-vue";
import { iscode } from "../../../../utils/app";
import store from "@/store";
export default {
  setup() {
    const code = ref("");
    const detail = ref({});
    const listLoading = ref(false);
    const listDone = ref(false);
    const searchResult = ref({});

    const initData = async () => {
      if (!code.value) {
        return message.error("请输入提货码");
      }
      let result = await getChannelOrderPickUpCodeSearch({ code: code.value })
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result, true)) {
        listDone.value = false;
        detail.value = result.data;
      } else {
        listDone.value = true;
        searchResult.value = result.msg;
      }
    };
    // 核销
    const writeOff = async () => {
      Modal.confirm({
        centered: true,
        title: "确定核销订单？",
        content: "确定后订单改成完成状态",
        onOk: async () => {
          let result = await getChannelOrderPickUpCodeWriteOff({
            order_no: detail.value.order_sn,
          })
            .then((res) => res.data)
            .catch((error) => error);
          if (iscode(result, true)) {
            // initData();
          }
        },
      });
    };
    const tableHoosks = {
      initData,
      detail,
      listDone,
      listLoading,
    };
    const columns = [
      {
        title: "商品名称",
        dataIndex: "good",
        key: "good",
        slots: { customRender: "good" },
      },
      {
        title: "规格",
        dataIndex: "goods_sku_name",
        key: "goods_sku_name",
        width: 300,
      },
      {
        title: "数量",
        dataIndex: "goods_num",
        key: "goods_num",
        width: 100,
      },
      {
        title: "支付积分",
        dataIndex: "point_price",
        key: "point_price",
        width: 100,
      },
      {
        title: "售后",
        dataIndex: "status_text",
        key: "status_text",
        width: 200,
      },
    ];
    return {
      code,
      columns,
      writeOff,
      searchResult,
      ...tableHoosks,
      info: store.state.user.info,
    };
  },
};
</script>